
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Calendar } from "lucide-react";

interface ExpenseFormFieldsProps {
  name: string;
  setName: (name: string) => void;
  category: string;
  setCategory: (category: string) => void;
  amount: string;
  setAmount: (amount: string) => void;
  date: string;
  setDate: (date: string) => void;
}

export function ExpenseFormFields({
  name,
  setName,
  category,
  setCategory,
  amount,
  setAmount,
  date,
  setDate
}: ExpenseFormFieldsProps) {
  return (
    <div className="grid grid-cols-1 gap-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label>Nome</Label>
          <Input 
            placeholder="Nome da despesa" 
            className="w-full bg-[#1A1F2C] text-white border-gray-700 focus:border-[#0073B7] focus:ring-[#0073B7]"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label>Categoria</Label>
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger className="w-full bg-[#1A1F2C] text-white border-gray-700">
              <SelectValue placeholder="Selecione a categoria" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="luz">Luz</SelectItem>
              <SelectItem value="internet">Internet</SelectItem>
              <SelectItem value="aluguel">Aluguel</SelectItem>
              <SelectItem value="agua">Água</SelectItem>
              <SelectItem value="salario">Salário</SelectItem>
              <SelectItem value="materia-prima">Matéria-Prima</SelectItem>
              <SelectItem value="ferramentas">Ferramentas</SelectItem>
              <SelectItem value="equipamentos">Equipamentos Pesados</SelectItem>
              <SelectItem value="outros">Outros</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label>Valor</Label>
          <Input 
            type="number" 
            placeholder="R$ 0,00" 
            className="w-full bg-[#1A1F2C] text-white border-gray-700 focus:border-[#0073B7] focus:ring-[#0073B7]"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <div className="space-y-2">
          <Label>Data de Vencimento</Label>
          <div className="relative">
            <Input 
              type="date" 
              className="w-full bg-[#1A1F2C] text-white border-gray-700 focus:border-[#0073B7] focus:ring-[#0073B7]"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <Calendar className="absolute right-3 top-2.5 h-5 w-5 text-gray-400" />
          </div>
        </div>
      </div>
    </div>
  );
}
